import { Component, Mixins } from "vue-property-decorator";
import PublishersMixin from "@/mixins/http/SpecialInitiatives/PublishersMixin";
import store from "@/store";

@Component
class SpecialInitiativesPublishersService extends Mixins(PublishersMixin) {
  created() {
    this.$store = store;
  }

  getPublishers() {
    return this.index();
  }
}

export default new SpecialInitiativesPublishersService();
